// extracted by mini-css-extract-plugin
export default {"form_container":"styles_form_container__lMzOd"};